<template>
  <div
    v-if="isExistSoftVersion"
  >
    <SoftVersionImage
      :image="softData.image"
      @click="isVisibleBottomSheet = true"
    />
    <CoreBottomSheet
      v-model="isVisibleBottomSheet"
    >
      <div class="text-h6 text--text mb-4">
        {{ tStatic('Пользуется порталом с версией') }} {{ softData.translate }}
      </div>

      <div class="d-flex flex-column gr-3 text-body-1">
        <div
          v-for="(benefit, i) in listBenefits"
          :key="i"
        >
          {{ getFirstLetterUpper(tStatic(benefit)) }}
        </div>
      </div>

      <template #actions>
        <v-btn
          block
          depressed
          color="primary"
          class="branding-btn branding-btn--primary"
          @click="isVisibleBottomSheet = false"
        >
          {{ tStatic('Понятно') }}
        </v-btn>
      </template>
    </CoreBottomSheet>
  </div>
</template>

<script lang="ts">
import getFirstLetterUpper from 'common/utils/getFirstLetterUpper'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import SoftVersionImage from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/components/common/SoftVersionImage.vue'
import { SoftVersionGlobalData } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/mixins'
import CoreBottomSheet from 'src/core/CoreBottomSheet/CoreBottomSheet.vue'

export default {
  name: 'SoftVersionIcon',
  components: {
    CoreBottomSheet,
    SoftVersionImage,
  },
  mixins: [
    SoftVersionGlobalData,
  ],
  setup() {
    return {
      tStatic,
      getFirstLetterUpper,
    }
  },
  data: () => ({
    isVisibleBottomSheet: false,
  }),
}
</script>
